import React from 'react';

const ClipboardIcon: React.FC<{ size?: number; strokeWidth?: number; className?: string }> = ({
  size = 19,
  strokeWidth = 2.5,
  className,
}) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={strokeWidth}
    strokeLinecap="round"
    strokeLinejoin="round"
    width={size}
    height={size}
    className={className}
  >
    <rect x="4" y="4" width="16" height="18" rx="3" ry="3" />
    <rect x="8" y="2" width="8" height="4" rx="1.5" ry="1.5" fill="currentColor" />
    <path d="M9 12h6" strokeWidth={strokeWidth + 0.5} />
    <path d="M9 16h6" strokeWidth={strokeWidth + 0.5} />
  </svg>
);

interface StockClerkLogoProps {
  showStatusDot?: boolean;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeConfig = {
  sm: { icon: 18, text: '17px', gap: '6px' },
  md: { icon: 19, text: '17px', gap: '6px' },
  lg: { icon: 32, text: '28px', gap: '10px' },
};

export const StockClerkLogo: React.FC<StockClerkLogoProps> = ({
  showStatusDot = false,
  size = 'md',
  className,
}) => {
  const config = sizeConfig[size];

  return (
    <span
      className={className}
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: config.gap,
      }}
    >
      <ClipboardIcon size={config.icon} />
      <span
        style={{
          fontFamily: "'Inter', system-ui, sans-serif",
          fontWeight: 700,
          fontSize: config.text,
          letterSpacing: '-0.02em',
          lineHeight: 1,
        }}
      >
        StockClerk
      </span>
      {showStatusDot && (
        <span
          className="stockclerk-status-dot"
          style={{
            width: 7,
            height: 7,
            borderRadius: 4,
            backgroundColor: '#5D8B55',
            border: '2px solid var(--color-background, #FAF8F5)',
            boxShadow: '0 0 8px rgba(93,139,85,0.3)',
            marginLeft: 3,
            flexShrink: 0,
          }}
        />
      )}
    </span>
  );
};

export { ClipboardIcon };
